<!-- <div class="resources-wrap" *ngIf="!noVideo && carouselReady">
    <div class="container container-mobile">
        <h2>Resources</h2>
        <p class="headerText">Watch to learn more about the importance of making a Will, considering your healthcare options, and thinking about your funeral wishes.</p>

        <owl-carousel-o [options]="customOptions" id="resourcesSlider">  
            <ng-container *ngFor="let data of videoData" >
              <ng-template  carouselSlide [id]="data._id">
                <div class="sliderContainer">
                <div class="video-wrap">
                    <img [src]="data.thumbnail" alt="Resources">
                    <div class="hoverDark"></div>
                    <div class="play-wrap" data-bs-toggle="modal" data-bs-target="#videoModal" data-bs-attr="data.s3FileKey" (click)="openVideo(data)">
                        <img src="../../../assets/images/play.svg" alt="Play" class="hoverImg">
                        <img src="../../../assets/images/play-white.svg" alt="Play" class="hoverWhiteImg">
                    </div>
                </div>
                <h2>{{data.title}}</h2>
                <p class="titleDesc" [title]="data.description">{{ (data.description.length > 87) ? (data.description | slice:0:87) + '...' : data.description }}
                  <span class="article-description">{{data.description}}</span></p>
              </div>
              </ng-template>
            </ng-container>              
        </owl-carousel-o>

    </div>
</div> -->

  <div class="resources-wrap2 article-wrap" *ngIf="!noTestimonial && carouselReady">
    <!-- <div class="container container-mobile"> -->
      <!-- <h2 class="mt-5">Testimonials</h2>
      <p class="headerText">Hear what our users have to say about Catholic Legacy and <a style="cursor: pointer;"
          (click)="contactUs()">contact us</a> with your feedback.</p>
      <owl-carousel-o [options]="customOptions2" id="resourcesSlider2">
        <ng-container *ngFor="let data of testimonailData">
          <ng-template carouselSlide [id]="data._id">
            <div class="sliderContainer" [ngClass]="{'oneTestimony': testimonailData.length === 1}">
              <div class="video-wrap-testimonial">
                <img [lazyLoad]="data.thumbnail" alt="Resources">

              </div>

              <div class="description-cotainer">

                <blockquote style="height: fit-content;">

                  {{ (data.clientTestimony.length > 200) ? (data.clientTestimony | slice:0:200) + '...' :
                  data.clientTestimony }}


                </blockquote>
                <div class="client-info">
                  <div class="client-name">
                    {{ (data.clientName.length > 20) ? (data.clientName | slice:0:20) + '...' : data.clientName }}
                  </div>

                </div>

              </div>

            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o> -->

      <section class="tcarousel-1-section">
        <h2 class="mt-5">Testimonials</h2>
        <p class="headerText">What Users Are Saying
          <!-- Hear what our users have to say about Catholic Legacy and
          <a class="link" style="cursor: pointer;">contact us</a> with
          your
          feedback. -->
        </p>
        <div class="tcarousel-1-wrapper" [class.two-items]="carouselItems?.length === 2">
      
          <div class="tcarousel-1-item" id="resourcesSlider3" *ngFor="let data of carouselItems; let i = index" [ngClass]="getCardClass(i)">
      
            <div class="tcarousel-1-card">
      
              <div class="tcarousel-1-image-wrapper">
                <img [src]="data.thumbnail" alt="Resources"/>
              </div>
      
              <div class="tcarousel-1-content">
                <div class="tcarousel-1-stars">
                  <ng-container *ngIf="data.rating && data.rating > 0">
                  <span *ngFor="let s of stars">
                    {{ s <= data.rating ? '★' : '☆' }} </span>
                  </ng-container>
                </div>
                <div class="tcarousel-1-text"><blockquote style="height: fit-content;">{{ (data.clientTestimony?.length > 200) ? (data.clientTestimony |
                        slice:0:200) +
                        '...' : data.clientTestimony }} </blockquote></div>
                <p class="tcarousel-1-name" [title]="data.clientName">- {{ (data.clientName?.length > 20) ? (data.clientName |
                          slice:0:20) + '...' :
                          data.clientName }}</p>
              </div>
      
            </div>
      
          </div>
      
        </div>
      </section>
  </div>

<!-- <div class="resources-wrap article-wrap" *ngIf="!noArticle && carouselReady">
  <div class="container container-mobile">
      <h2 class="mt-5">Articles</h2>
      <p class="headerText">Access a wealth of resources from Relevant Radio writers and show hosts about critical issues and teachings of the Catholic Church on end-of-life decisions.</p>
      <owl-carousel-o [options]="customOptions" id="resourcesSlider">  
          <ng-container *ngFor="let data of articleData">
            <ng-template carouselSlide [id]="data._id">
              <div class="video-wrap">
                  <a [href]="data.url" target="_blank"><img [src]="data.thumbnail" alt="Resources"></a>
              </div>
              <h2><a [href]="data.url" target="_blank" class="link-unstyled">{{data.title}}</a></h2>
              <p class="titleDesc"  [title]="data.description" ><a [href]="data.url" target="_blank" class="link-unstyled">
                {{ (data.description.length > 90) ? (data.description | slice:0:90) + '...' : data.description }}
                <span  class="article-description">{{data.description}}</span></a></p>
            </ng-template>
          </ng-container>              
      </owl-carousel-o>
  </div>
</div> -->

<!-- <div class="resources-wrap-new article-wrap" *ngIf="!noArticle">
  <div class="container container-mobile">
      <div class="article-header">Articles</div>
      <owl-carousel-o [options]="customOptionsArticles" id="resourcesSlidernew">  
          <ng-container *ngFor="let data of articleData">
            <ng-template carouselSlide [id]="data._id">
              <div class="video-wrap">
                  <a (click)="readMore(data)" target="_blank"><img [src]="data.thumbnail" alt="Resources"></a>
                  <div class="realted-article-badge">{{data.articleCategoryType || '-'}}</div>
              </div>
              <h2><a [href]="data.url" target="_blank" class="link-unstyled">{{data?.title}}</a></h2>
               <span class="article-date">{{data?.created_at | date}}&nbsp;&nbsp; &nbsp;{{data?.readTime || ''}}<ng-container *ngIf="data.readTime"> Read</ng-container></span>
              <p class="titleDesc"  [title]="data.description" ><a [href]="data.url" target="_blank" class="link-unstyled">
                {{ (data.description.length > 90) ? (removeHtmlTags(data.description) | slice:0:90) + '...' : removeHtmlTags(data.description) }}
                <span  class="article-description">{{removeHtmlTags(data.description)}}</span></a></p>
                <span class="read-more" (click)="readMore(data)">Read More</span>
            </ng-template>
          </ng-container>              
      </owl-carousel-o>
  </div>
</div> -->

<div class="container article-container">
  <div class="article-header" *ngIf="articleData?.length">Articles</div>
  <div class="row" >
    <ng-container *ngFor="let data of articleData?.slice(0, 3); let i = index">
      <div class="col-md-4 col-sm-6 mb-4" (click)="readMore(data)">
        <div class="video-wrap">
          <a (click)="readMore(data)" target="_blank">
            <img [lazyLoad]="data.thumbnail" alt="Resources">
          </a>
          <div class="realted-article-badge">{{data.articleCategoryType || '-'}}</div>
        </div>
        <h2>
          <a (click)="readMore(data)" [title]="data?.title" target="_blank" class="link-unstyled">{{ data?.title }}</a>
        </h2>
        <span class="article-date">
          {{data?.created_at | date}} &nbsp;&nbsp; {{data.readTime || ''}}
          <ng-container *ngIf="data.readTime"> Read</ng-container>
        </span>
        <p class="titleDesc">
          <a  target="_blank" class="link-unstyled praDesc">
            {{ removeHtmlTags(data.description) }}
          </a>
        </p>
        <span class="read-more" (click)="readMore(data)">Read More</span>
      </div>
    </ng-container>
  </div>

  <div class="text-center mt-4" *ngIf="articleData?.length">
      <button class="btn explore-more-btn btn-primary btn-block" (click)="redirectToArticle()">Explore More Articles</button>
    </div>
</div>

<!-- <div class="modal fade" id="videoModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="videoModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
          <button type="button" class="btn-close" (click)="closeVideoModal()" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
          <video *ngIf="!isVideoYoutubeUrl" width="100%" controls autoplay [src]="videoUrl" type="video/mp4">
              Your browser does not support the video tag.
          </video>
          <iframe width="100%" height="380" [src]="youTubeUrl" *ngIf="isVideoYoutubeUrl">
          </iframe>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div> -->